import { routeAlias, routeNames, routePaths } from '@/router/router-constants'
import type { RouteRecordRaw } from 'vue-router'

export const recordTypeRoutes: RouteRecordRaw[] = [
  {
    path: routePaths.recordTypes,
    component: () => import('@/pages/record-types/RecordTypesView.vue'),
    meta: {
      permission: 'record-types.read.all',
      labelKey: 'recordTypes',
      icon: 'material-symbols-outlined',
      iconText: 'checklist',
      featureFlag: 'records',
    },
    children: [
      {
        name: routeNames.recordTypes,
        path: '',
        component: () => import('@/pages/record-types/tabs/RecordTypesTab.vue'),
        meta: {
          permission: 'record-types.read.all',
          labelKey: 'recordTypes',
          rootRouteName: routeNames.recordTypes,
          featureFlag: 'records',
        },
      },
      {
        path: routePaths.recordTypesCaseRecords,
        name: routeNames.recordTypesCaseRecords,
        component: () => import('@/pages/record-types/tabs/CaseRecordTypesTab.vue'),
        meta: {
          permission: 'record-types.read.all',
          labelKey: 'caseRecordTypes',
          rootRouteName: routeNames.recordTypes,
          featureFlag: 'records',
        },
      },
    ],
  },
  {
    path: routePaths.recordTypeDetails,
    name: routeNames.recordTypeDetails,
    component: () => import('@/pages/record-types/RecordTypeDetailsView.vue'),
    meta: {
      permission: 'record-types.read.all',
      rootRouteName: routeNames.recordTypes,
      featureFlag: 'records',
    },
  },
  {
    path: routePaths.recordTypeFields,
    name: routeNames.recordTypeFields,
    redirect: { name: routeNames.recordTypeDetails },
    meta: {
      permission: 'record-types.read.all',
      labelKey: 'specificFields',
      rootRouteName: routeNames.recordTypes,
    },
  },
  {
    path: routePaths.recordTypeCreation,
    name: routeNames.recordTypeCreation,
    component: () => import('@/pages/record-types/AddEditRecordTypeView.vue'),
    meta: {
      permission: 'record-types.write.all',
      labelKey: 'new_m',
      rootRouteName: routeNames.recordTypes,
      featureFlag: 'records',
    },
  },
  {
    path: routePaths.recordTypeEdit,
    name: routeNames.recordTypeEdit,
    component: () => import('@/pages/record-types/AddEditRecordTypeView.vue'),
    meta: {
      permission: 'record-types.write.all',
      labelKey: 'edit',
      rootRouteName: routeNames.recordTypes,
      featureFlag: 'records',
    },
  },
  {
    path: routePaths.recordTypeFieldCreation,
    name: routeNames.recordTypeFieldCreation,
    component: () => import('@/pages/record-types/fields/AddRecordTypeFieldView.vue'),
    meta: {
      permission: 'record-types.write.all',
      labelKey: 'new_m',
      rootRouteName: routeNames.recordTypes,
    },
  },
  {
    path: routePaths.recordTypeFieldEdit,
    name: routeNames.recordTypeFieldEdit,
    alias: routeAlias.recordTypeFieldEdit,
    component: () => import('@/pages/record-types/fields/EditRecordTypeFieldView.vue'),
    meta: {
      permission: 'record-types.write.all',
      labelKey: 'edit',
      rootRouteName: routeNames.recordTypes,
    },
  },
]
